module.exports = __webpack_public_path__ + "img/Rectangle Copy 13@322x.2290808b.png";